export type vertexData = {
  key: string;
  options: {
    ref?: string | null;
    objectId?: string;
  };
};

export type edgeData = {
  key: string;
  weight: number;
};

export type objectData = {
  key: string;
  ref: string;
};

export type mapData = {
  v: { [key: string]: vertexData };
  e: { [key: string]: edgeData };
  o: { [key: string]: objectData };
};

export const mapData = {
  v: {
    v_1: {
      key: "v_1",
      options: {
        ref: null,
      },
    },
    v_2: {
      key: "v_2",
      options: {
        ref: null,
        objectId: "o_17",
      },
    },
    v_3: {
      key: "v_3",
      options: {
        ref: null,
        objectId: "o_29",
      },
    },
    v_4: {
      key: "v_4",
      options: {
        ref: null,
      },
    },
    v_5: {
      key: "v_5",
      options: {
        ref: null,
      },
    },
    v_6: {
      key: "v_6",
      options: {
        ref: null,
        objectId: "o_7",
      },
    },
    v_7: {
      key: "v_7",
      options: {
        ref: null,
      },
    },
    v_8: {
      key: "v_8",
      options: {
        ref: null,
      },
    },
    v_9: {
      key: "v_9",
      options: {
        ref: null,
        objectId: "o_8",
      },
    },
    v_10: {
      key: "v_10",
      options: {
        ref: null,
        objectId: "o_2",
      },
    },
    v_11: {
      key: "v_11",
      options: {
        ref: null,
      },
    },
    v_12: {
      key: "v_12",
      options: {
        ref: null,
        objectId: "o_22",
      },
    },
    v_13: {
      key: "v_13",
      options: {
        ref: null,
      },
    },
    v_14: {
      key: "v_14",
      options: {
        ref: null,
        objectId: "o_4",
      },
    },
    v_15: {
      key: "v_15",
      options: {
        ref: null,
      },
    },
    v_16: {
      key: "v_16",
      options: {
        ref: null,
        objectId: "o_31",
      },
    },
    v_17: {
      key: "v_17",
      options: {
        ref: null,
      },
    },
    v_18: {
      key: "v_18",
      options: {
        ref: null,
        objectId: "o_23",
      },
    },
    v_19: {
      key: "v_19",
      options: {
        ref: null,
      },
    },
    v_20: {
      key: "v_20",
      options: {
        ref: null,
      },
    },
    v_21: {
      key: "v_21",
      options: {
        ref: null,
      },
    },
    v_22: {
      key: "v_22",
      options: {
        ref: null,
        objectId: "o_39",
      },
    },
    v_23: {
      key: "v_23",
      options: {
        ref: null,
        objectId: "o_13",
      },
    },
    v_24: {
      key: "v_24",
      options: {
        ref: null,
      },
    },
    v_25: {
      key: "v_25",
      options: {
        ref: null,
        objectId: "o_32",
      },
    },
    v_26: {
      key: "v_26",
      options: {
        ref: null,
      },
    },
    v_27: {
      key: "v_27",
      options: {
        ref: null,
        objectId: "o_15",
      },
    },
    v_28: {
      key: "v_28",
      options: {
        ref: null,
        objectId: "o_16",
      },
    },
    v_29: {
      key: "v_29",
      options: {
        ref: null,
      },
    },
    v_30: {
      key: "v_30",
      options: {
        ref: null,
      },
    },
    v_31: {
      key: "v_31",
      options: {
        ref: null,
      },
    },
    v_32: {
      key: "v_32",
      options: {
        ref: null,
        objectId: "o_18",
      },
    },
    v_33: {
      key: "v_33",
      options: {
        ref: null,
      },
    },
    v_34: {
      key: "v_34",
      options: {
        ref: null,
      },
    },
    v_35: {
      key: "v_35",
      options: {
        ref: null,
        objectId: "o_41",
      },
    },
    v_36: {
      key: "v_36",
      options: {
        ref: null,
      },
    },
    v_37: {
      key: "v_37",
      options: {
        ref: null,
        objectId: "o_20",
      },
    },
    v_38: {
      key: "v_38",
      options: {
        ref: null,
      },
    },
    v_39: {
      key: "v_39",
      options: {
        ref: null,
        objectId: "o_21",
      },
    },
    v_40: {
      key: "v_40",
      options: {
        ref: null,
        objectId: "o_19",
      },
    },
    v_41: {
      key: "v_41",
      options: {
        ref: null,
      },
    },
    v_42: {
      key: "v_42",
      options: {
        ref: null,
      },
    },
    v_43: {
      key: "v_43",
      options: {
        ref: null,
      },
    },
    v_44: {
      key: "v_44",
      options: {
        ref: null,
      },
    },
    v_45: {
      key: "v_45",
      options: {
        ref: null,
      },
    },
    v_46: {
      key: "v_46",
      options: {
        ref: null,
        objectId: "o_28",
      },
    },
    v_47: {
      key: "v_47",
      options: {
        ref: null,
      },
    },
    v_48: {
      key: "v_48",
      options: {
        ref: null,
        objectId: "o_33",
      },
    },
    v_49: {
      key: "v_49",
      options: {
        ref: null,
        objectId: "o_34",
      },
    },
    v_50: {
      key: "v_50",
      options: {
        ref: null,
        objectId: "o_30",
      },
    },
    v_51: {
      key: "v_51",
      options: {
        ref: null,
      },
    },
    v_52: {
      key: "v_52",
      options: {
        ref: null,
      },
    },
    v_53: {
      key: "v_53",
      options: {
        ref: null,
      },
    },
    v_54: {
      key: "v_54",
      options: {
        ref: null,
        objectId: "o_26",
      },
    },
    v_55: {
      key: "v_55",
      options: {
        ref: null,
      },
    },
    v_56: {
      key: "v_56",
      options: {
        ref: null,
      },
    },
    v_57: {
      key: "v_57",
      options: {
        ref: null,
        objectId: "o_25",
      },
    },
    v_58: {
      key: "v_58",
      options: {
        ref: null,
      },
    },
    v_59: {
      key: "v_59",
      options: {
        ref: null,
        objectId: "o_36",
      },
    },
    v_60: {
      key: "v_60",
      options: {
        ref: null,
        objectId: "o_27",
      },
    },
    v_61: {
      key: "v_61",
      options: {
        ref: null,
      },
    },
    v_62: {
      key: "v_62",
      options: {
        ref: null,
      },
    },
    v_63: {
      key: "v_63",
      options: {
        ref: null,
        objectId: "o_38",
      },
    },
    v_64: {
      key: "v_64",
      options: {
        ref: null,
      },
    },
    v_65: {
      key: "v_65",
      options: {
        ref: null,
      },
    },
    v_66: {
      key: "v_66",
      options: {
        ref: null,
      },
    },
    v_67: {
      key: "v_67",
      options: {
        ref: null,
      },
    },
    v_68: {
      key: "v_68",
      options: {
        ref: null,
        objectId: "o_6",
      },
    },
    v_69: {
      key: "v_69",
      options: {
        ref: null,
      },
    },
    v_70: {
      key: "v_70",
      options: {
        ref: null,
        objectId: "o_14",
      },
    },
    v_71: {
      key: "v_71",
      options: {
        ref: null,
        objectId: "o_24",
      },
    },
    v_72: {
      key: "v_72",
      options: {
        ref: null,
      },
    },
    v_73: {
      key: "v_73",
      options: {
        ref: null,
        objectId: "o_9",
      },
    },
    v_74: {
      key: "v_74",
      options: {
        ref: null,
      },
    },
    v_75: {
      key: "v_75",
      options: {
        ref: null,
      },
    },
    v_76: {
      key: "v_76",
      options: {
        ref: null,
        objectId: "o_3",
      },
    },
    v_77: {
      key: "v_77",
      options: {
        ref: null,
        objectId: "o_10",
      },
    },
    v_78: {
      key: "v_78",
      options: {
        ref: null,
        objectId: "o_40",
      },
    },
    v_79: {
      key: "v_79",
      options: {
        ref: null,
      },
    },
    v_80: {
      key: "v_80",
      options: {
        ref: "o_42",
      },
    },
    v_81: {
      key: "v_81",
      options: {
        ref: null,
      },
    },
    v_82: {
      key: "v_82",
      options: {
        ref: null,
      },
    },
    v_83: {
      key: "v_83",
      options: {
        ref: null,
        objectId: "o_35",
      },
    },
    v_84: {
      key: "v_84",
      options: {
        ref: null,
      },
    },
    v_85: {
      key: "v_85",
      options: {
        ref: null,
        objectId: "o_37",
      },
    },
    v_86: {
      key: "v_86",
      options: {
        ref: null,
      },
    },
    v_87: {
      key: "v_87",
      options: {
        ref: null,
        objectId: "o_11",
      },
    },
    v_88: {
      key: "v_88",
      options: {
        ref: null,
        objectId: "o_5",
      },
    },
    v_89: {
      key: "v_89",
      options: {
        ref: null,
      },
    },
    v_90: {
      key: "v_90",
      options: {
        ref: null,
        objectId: "o_1",
      },
    },
    v_91: {
      key: "v_91",
      options: {
        ref: null,
      },
    },
    v_92: {
      key: "v_92",
      options: {
        ref: null,
        objectId: "o_43",
      },
    },
    v_93: {
      key: "v_93",
      options: {
        ref: null,
        objectId: "o_12",
      },
    },
    v_94: {
      key: "v_94",
      options: {
        ref: null,
      },
    },
    v_95: {
      key: "v_95",
      options: {
        ref: null,
      },
    },
    v_96: {
      key: "v_96",
      options: {
        ref: null,
      },
    },
  },

  e: {
    v_96__v_79: {
      key: "v_96__v_79",
      weight: 1,
    },
    v_79__v_75: {
      key: "v_79__v_75",
      weight: 1,
    },
    v_69__v_67: {
      key: "v_69__v_67",
      weight: 1,
    },
    v_72__v_71: {
      key: "v_72__v_71",
      weight: 1,
    },
    v_29__v_28: {
      key: "v_29__v_28",
      weight: 1,
    },
    v_26__v_27: {
      key: "v_26__v_27",
      weight: 1,
    },
    v_26__v_25: {
      key: "v_26__v_25",
      weight: 1,
    },
    v_74__v_70: {
      key: "v_74__v_70",
      weight: 1,
    },
    v_74__v_73: {
      key: "v_74__v_73",
      weight: 1,
    },
    v_15__v_14: {
      key: "v_15__v_14",
      weight: 1,
    },
    v_19__v_18: {
      key: "v_19__v_18",
      weight: 1,
    },
    v_17__v_16: {
      key: "v_17__v_16",
      weight: 1,
    },
    v_4__v_3: {
      key: "v_4__v_3",
      weight: 1,
    },
    v_4__v_2: {
      key: "v_4__v_2",
      weight: 1,
    },
    v_13__v_12: {
      key: "v_13__v_12",
      weight: 1,
    },
    v_69__v_68: {
      key: "v_69__v_68",
      weight: 1,
    },
    v_24__v_21: {
      key: "v_24__v_21",
      weight: 1,
    },
    v_45__v_24: {
      key: "v_45__v_24",
      weight: 1,
    },
    v_44__v_45: {
      key: "v_44__v_45",
      weight: 1,
    },
    v_44__v_53: {
      key: "v_44__v_53",
      weight: 1,
    },
    v_81__v_53: {
      key: "v_81__v_53",
      weight: 1,
    },
    v_82__v_81: {
      key: "v_82__v_81",
      weight: 1,
    },
    v_36__v_34: {
      key: "v_36__v_34",
      weight: 1,
    },
    v_42__v_36: {
      key: "v_42__v_36",
      weight: 1,
    },
    v_33__v_32: {
      key: "v_33__v_32",
      weight: 1,
    },
    v_41__v_40: {
      key: "v_41__v_40",
      weight: 1,
    },
    v_41__v_39: {
      key: "v_41__v_39",
      weight: 1,
    },
    v_38__v_37: {
      key: "v_38__v_37",
      weight: 1,
    },
    v_42__v_43: {
      key: "v_42__v_43",
      weight: 1,
    },
    v_43__v_1: {
      key: "v_43__v_1",
      weight: 1,
    },
    v_20__v_1: {
      key: "v_20__v_1",
      weight: 1,
    },
    v_8__v_5: {
      key: "v_8__v_5",
      weight: 1,
    },
    v_5__v_7: {
      key: "v_5__v_7",
      weight: 1,
    },
    v_7__v_31: {
      key: "v_7__v_31",
      weight: 1,
    },
    v_20__v_15: {
      key: "v_20__v_15",
      weight: 1,
    },
    v_11__v_8: {
      key: "v_11__v_8",
      weight: 1,
    },
    v_67__v_66: {
      key: "v_67__v_66",
      weight: 1,
    },
    v_51__v_50: {
      key: "v_51__v_50",
      weight: 1,
    },
    v_47__v_46: {
      key: "v_47__v_46",
      weight: 1,
    },
    v_55__v_54: {
      key: "v_55__v_54",
      weight: 1,
    },
    v_30__v_48: {
      key: "v_30__v_48",
      weight: 1,
    },
    v_52__v_49: {
      key: "v_52__v_49",
      weight: 1,
    },
    v_65__v_66: {
      key: "v_65__v_66",
      weight: 1,
    },
    v_65__v_56: {
      key: "v_65__v_56",
      weight: 1,
    },
    v_56__v_64: {
      key: "v_56__v_64",
      weight: 1,
    },
    v_62__v_64: {
      key: "v_62__v_64",
      weight: 1,
    },
    v_89__v_62: {
      key: "v_89__v_62",
      weight: 1,
    },
    v_89__v_88: {
      key: "v_89__v_88",
      weight: 1,
    },
    v_86__v_85: {
      key: "v_86__v_85",
      weight: 1,
    },
    v_83__v_84: {
      key: "v_83__v_84",
      weight: 1,
    },
    v_84__v_87: {
      key: "v_84__v_87",
      weight: 1,
    },
    v_61__v_59: {
      key: "v_61__v_59",
      weight: 1,
    },
    v_58__v_57: {
      key: "v_58__v_57",
      weight: 1,
    },
    v_61__v_60: {
      key: "v_61__v_60",
      weight: 1,
    },
    v_91__v_94: {
      key: "v_91__v_94",
      weight: 1,
    },
    v_91__v_90: {
      key: "v_91__v_90",
      weight: 1,
    },
    v_96__v_94: {
      key: "v_96__v_94",
      weight: 1,
    },
    v_75__v_69: {
      key: "v_75__v_69",
      weight: 1,
    },
    v_75__v_76: {
      key: "v_75__v_76",
      weight: 1,
    },
    v_96__v_65: {
      key: "v_96__v_65",
      weight: 1,
    },
    v_64__v_63: {
      key: "v_64__v_63",
      weight: 1,
    },
    v_92__v_94: {
      key: "v_92__v_94",
      weight: 1,
    },
    v_94__v_93: {
      key: "v_94__v_93",
      weight: 1,
    },
    v_95__v_96: {
      key: "v_95__v_96",
      weight: 1,
    },
    v_52__v_66: {
      key: "v_52__v_66",
      weight: 1,
    },
    v_30__v_67: {
      key: "v_30__v_67",
      weight: 1,
    },
    v_79__v_78: {
      key: "v_79__v_78",
      weight: 1,
    },
    v_79__v_77: {
      key: "v_79__v_77",
      weight: 1,
    },
    v_29__v_30: {
      key: "v_29__v_30",
      weight: 1,
    },
    v_26__v_29: {
      key: "v_26__v_29",
      weight: 1,
    },
    v_24__v_26: {
      key: "v_24__v_26",
      weight: 1,
    },
    v_24__v_23: {
      key: "v_24__v_23",
      weight: 1,
    },
    v_20__v_22: {
      key: "v_20__v_22",
      weight: 1,
    },
    v_51__v_52: {
      key: "v_51__v_52",
      weight: 1,
    },
    v_47__v_51: {
      key: "v_47__v_51",
      weight: 1,
    },
    v_45__v_47: {
      key: "v_45__v_47",
      weight: 1,
    },
    v_55__v_53: {
      key: "v_55__v_53",
      weight: 1,
    },
    v_81__v_58: {
      key: "v_81__v_58",
      weight: 1,
    },
    v_81__v_80: {
      key: "v_81__v_80",
      weight: 1,
    },
    v_58__v_61: {
      key: "v_58__v_61",
      weight: 1,
    },
    v_61__v_62: {
      key: "v_61__v_62",
      weight: 1,
    },
    v_86__v_89: {
      key: "v_86__v_89",
      weight: 1,
    },
    v_84__v_86: {
      key: "v_84__v_86",
      weight: 1,
    },
    v_82__v_84: {
      key: "v_82__v_84",
      weight: 1,
    },
    v_34__v_82: {
      key: "v_34__v_82",
      weight: 1,
    },
    v_89__v_91: {
      key: "v_89__v_91",
      weight: 1,
    },
    v_56__v_55: {
      key: "v_56__v_55",
      weight: 1,
    },
    v_69__v_72: {
      key: "v_69__v_72",
      weight: 1,
    },
    v_72__v_74: {
      key: "v_72__v_74",
      weight: 1,
    },
    v_74__v_21: {
      key: "v_74__v_21",
      weight: 1,
    },
    v_21__v_15: {
      key: "v_21__v_15",
      weight: 1,
    },
    v_19__v_20: {
      key: "v_19__v_20",
      weight: 1,
    },
    v_17__v_19: {
      key: "v_17__v_19",
      weight: 1,
    },
    v_8__v_17: {
      key: "v_8__v_17",
      weight: 1,
    },
    v_4__v_5: {
      key: "v_4__v_5",
      weight: 1,
    },
    v_7__v_6: {
      key: "v_7__v_6",
      weight: 1,
    },
    v_1__v_4: {
      key: "v_1__v_4",
      weight: 1,
    },
    v_41__v_42: {
      key: "v_41__v_42",
      weight: 1,
    },
    v_36__v_33: {
      key: "v_36__v_33",
      weight: 1,
    },
    v_36__v_35: {
      key: "v_36__v_35",
      weight: 1,
    },
    v_38__v_41: {
      key: "v_38__v_41",
      weight: 1,
    },
    v_31__v_38: {
      key: "v_31__v_38",
      weight: 1,
    },
    v_43__v_44: {
      key: "v_43__v_44",
      weight: 1,
    },
    v_15__v_13: {
      key: "v_15__v_13",
      weight: 1,
    },
    v_13__v_11: {
      key: "v_13__v_11",
      weight: 1,
    },
    v_11__v_10: {
      key: "v_11__v_10",
      weight: 1,
    },
    v_8__v_9: {
      key: "v_8__v_9",
      weight: 1,
    },
  },

  o: {
    o_1: {
      key: "o_1",
      ref: "v_90",
    },
    o_2: {
      key: "o_2",
      ref: "v_10",
    },
    o_3: {
      key: "o_3",
      ref: "v_76",
    },
    o_4: {
      key: "o_4",
      ref: "v_14",
    },
    o_5: {
      key: "o_5",
      ref: "v_88",
    },
    o_6: {
      key: "o_6",
      ref: "v_68",
    },
    o_7: {
      key: "o_7",
      ref: "v_6",
    },
    o_8: {
      key: "o_8",
      ref: "v_9",
    },
    o_9: {
      key: "o_9",
      ref: "v_73",
    },
    o_10: {
      key: "o_10",
      ref: "v_77",
    },
    o_11: {
      key: "o_11",
      ref: "v_87",
    },
    o_12: {
      key: "o_12",
      ref: "v_93",
    },
    o_13: {
      key: "o_13",
      ref: "v_23",
    },
    o_14: {
      key: "o_14",
      ref: "v_70",
    },
    o_15: {
      key: "o_15",
      ref: "v_27",
    },
    o_16: {
      key: "o_16",
      ref: "v_28",
    },
    o_17: {
      key: "o_17",
      ref: "v_2",
    },
    o_18: {
      key: "o_18",
      ref: "v_32",
    },
    o_19: {
      key: "o_19",
      ref: "v_40",
    },
    o_20: {
      key: "o_20",
      ref: "v_37",
    },
    o_21: {
      key: "o_21",
      ref: "v_39",
    },
    o_22: {
      key: "o_22",
      ref: "v_12",
    },
    o_23: {
      key: "o_23",
      ref: "v_18",
    },
    o_24: {
      key: "o_24",
      ref: "v_71",
    },
    o_25: {
      key: "o_25",
      ref: "v_57",
    },
    o_26: {
      key: "o_26",
      ref: "v_54",
    },
    o_27: {
      key: "o_27",
      ref: "v_60",
    },
    o_28: {
      key: "o_28",
      ref: "v_46",
    },
    o_29: {
      key: "o_29",
      ref: "v_3",
    },
    o_30: {
      key: "o_30",
      ref: "v_50",
    },
    o_31: {
      key: "o_31",
      ref: "v_16",
    },
    o_32: {
      key: "o_32",
      ref: "v_25",
    },
    o_33: {
      key: "o_33",
      ref: "v_48",
    },
    o_34: {
      key: "o_34",
      ref: "v_49",
    },
    o_35: {
      key: "o_35",
      ref: "v_83",
    },
    o_36: {
      key: "o_36",
      ref: "v_59",
    },
    o_37: {
      key: "o_37",
      ref: "v_85",
    },
    o_38: {
      key: "o_38",
      ref: "v_63",
    },
    o_39: {
      key: "o_39",
      ref: "v_22",
    },
    o_40: {
      key: "o_40",
      ref: "v_78",
    },
    o_41: {
      key: "o_41",
      ref: "v_35",
    },
    o_42: {
      key: "o_42",
      ref: "v_80",
    },
    o_43: {
      key: "o_43",
      ref: "v_92",
    },
  },
};
